import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import * as actions from '../Actions.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react';

export class FormDetailLocalidadesBeneficiadas extends Component {
  static propTypes = {
    pageLocalidadesBeneficiadas: PropTypes.object.isRequired,
    findLocalidadesBeneficiadas: PropTypes.func.isRequired,
    idEmenda: PropTypes.number.isRequired
  };

  componentDidMount() {
    this.searchWithPage(
      this.props.pageLocalidadesBeneficiadas.set('number', 0).set('size', 20)
    );
  }

  searchWithPage = page => {
    const { findLocalidadesBeneficiadas, idEmenda } = this.props;
    findLocalidadesBeneficiadas(idEmenda, page);
  };

  renderRow = (localidadesbeneficiadas, index) => {
    return (
      <tr key={index}>
        <td>{localidadesbeneficiadas.get('descricao')}</td>
      </tr>
    );
  };

  render() {
    const { pageLocalidadesBeneficiadas } = this.props;
    const content = pageLocalidadesBeneficiadas.get('content', List());

    return (
      <div>
        {content.size > 0 ? (
          <table className="panel-table striped fancy">
            <TableHeader empty={content.isEmpty()}>
              <tr>
                <th>Nome</th>
              </tr>
            </TableHeader>
            <tbody>{content.map(this.renderRow)}</tbody>
          </table>
        ) : (
          <div className="empty-state">Nenhuma localidade encontrada.</div>
        )}
        <SearchPagination
          page={pageLocalidadesBeneficiadas}
          searchWithPage={this.searchWithPage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageLocalidadesBeneficiadas: state.emendaContabilidade.get(
      'localidadesbeneficiadas'
    )
  };
}

const allActions = {
  findLocalidadesBeneficiadas: actions.findLocalidadesBeneficiadas
};

export default connect(
  mapStateToProps,
  allActions
)(FormDetailLocalidadesBeneficiadas);
